import { useQuery } from 'react-query';
import { baseApiUrl, fetcher, ServerErrorResponse } from 'data_sources/constants';
import { CRQuestion } from 'views/App/Portal/Policy/_types/crq';

export default function useCRQ(
  manualId: string,
  id?: string,
  options = {},
  onError?: (errors: ServerErrorResponse) => void
) {
  const url = `${baseApiUrl()}/lexiverse/manual-crq/v1/manuals/${manualId}/questions/${id}`;
  return useQuery<CRQuestion, ServerErrorResponse>(
    ['draft_manual_crq', manualId, id],
    async () => {
      try {
        const data = await fetcher({
          method: 'get',
          url,
        });
        return data;
      } catch (error: unknown) {
        if (onError && typeof error === 'object' && error !== null && 'errorDetails' in error) {
          onError(error as ServerErrorResponse);
        }
        throw error;
      }
    },
    {
      ...options,
      enabled: !!id,
    }
  );
}
